import { updateFieldObject, updateFieldObjectAndDisable } from '../../util/updateFieldObject'
import { PRODUCTS } from '../../constant/PRODUCTS'

const mapPinValidationResponseToFormState = (state, payload) => {
  const anyProductSelected = PRODUCTS.some(product => payload[product].toLowerCase() === 'yes')
  PRODUCTS.forEach(product => {
    state.options[product] = updateFieldObject(state.options, product, payload[product].toLowerCase() === 'yes', anyProductSelected)
  })
  state.options.applicantType = updateFieldObjectAndDisable(state.options, 'applicantType', payload.eoiApplicantType)
  state.segments.dependents.enabled = payload.eoiApplicantType !== 'EE_ONLY'
  state.options.disability.value = payload.eoiApplicantType === 'SP_ONLY' ? false : state.options.disability.value
}
export default mapPinValidationResponseToFormState